import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bc-filter',
  templateUrl: './bc-filter.component.html',
  styleUrls: ['./bc-filter.component.scss']
})
export class BcFilterListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-filter/bc-filter.component.ts